<template>
  <AbsentToday :is-subs-today="false" :is-public="true"></AbsentToday>
</template>

<script>
import AbsentToday from '../Subs/OverviewToday'
export default {
  components: {AbsentToday},
  computed: {
    schoolUuid () {
      return this.$route.params.school_uuid
    }
  },
  mounted () {
    console.log('this.$route', this.$route)
  }
}
</script>



// WEBPACK FOOTER //
// OverviewTodayAbsentPublic.vue?29d2e6a8